import {useDispatch, useSelector} from 'react-redux'
import {AdminProductDTO, AdminProductPageDataApiData} from '../../../api/data-contracts'
import {getAdminState, setProductsPageData} from '../../../redux/adminSlice'
import _ from 'lodash'
import BootstrapTable, {ColumnDescription} from 'react-bootstrap-table-next'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import filterFactory, {selectFilter, textFilter} from 'react-bootstrap-table2-filter'

import {Api_Admin_GetProductsPage} from '../../../apiClient/apiClient'
import {postRequestAsync} from '../../../redux/commonSlice'
import {useEffect, useState} from 'react'
import {getCurrencySymbol} from '../../../utils/utilities'
import clsx from 'clsx'
import AdminProductEditPage from './AdminProductEditPage'
import {CanIDoThat} from '../../../utils/CanIDoThat'
import {UserTypeAuthorizationsEnum} from '../../../apiClient/enums'
import {KTSVG} from '../../../../_metronic/helpers'

function AdminProductsPage() {
  const dispatch = useDispatch()
  const adminState = useSelector(getAdminState)
  const [editingProduct, setEditingProduct] = useState<AdminProductDTO | null>(null)
  const [isNewProduct, setIsNewProduct] = useState(false)

  useEffect(() => {
    dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_Admin_GetProductsPage,
        body: {},
      })
    )
      .unwrap()
      .then(async function (response: AdminProductPageDataApiData) {
        dispatch<any>(setProductsPageData(response.data))
      })
  }, [])

  const sortedProducts =
    _.orderBy(
      adminState.productsPage?.products,
      [
        (o) => (o.typeId === 3 ? 0 : o.typeId === 4 ? 1 : 2),
        (o) => (o.categoryId === 6 ? 0 : 1),
        (o) => o.title?.toLocaleLowerCase('tr') ?? '',
      ],
      ['asc', 'asc', 'asc']
    ) ?? []

  function filterByActive(filterVal: any) {
    if (filterVal === '1') {
      return sortedProducts.filter((p: AdminProductDTO) => p.isActive)
    } else if (filterVal === '0') {
      return sortedProducts.filter((p: AdminProductDTO) => !p.isActive)
    }
    return sortedProducts
  }

  const columns: ColumnDescription[] = [
    {
      dataField: 'isActive',
      text: 'Aktif',
      sort: true,
      headerStyle: {width: '10%'},
      // formatter: cell => adminState.productsPage?.productTypes?.at(cell),
      filter: selectFilter({
        options: [
          {
            label: 'Aktif',
            value: 1,
          },
          {
            label: 'Pasif',
            value: 0,
          },
        ],
        onFilter: filterByActive,
        defaultValue: 1,
      }),
      formatter: (cell: any, m: AdminProductDTO, rowIndex: number, colIndex: number) => (
        <>{m.isActive && <i className='bi bi-check fs-2x text-success text-center'></i>}</>
      ),
    },
    {
      dataField: 'title',
      text: 'Adı',
      sort: true,
      headerStyle: {width: '30%'},
      filter: textFilter(),
      formatter: (cell: any, m: AdminProductDTO, rowIndex: number, colIndex: number) => (
        <>
          <div className='text-dark fw-bold d-block fs-6'>{m.title}</div>
        </>
      ),
    },
    {
      dataField: 'typeId',
      text: 'Tip',
      sort: true,
      headerStyle: {width: '20%'},
      filter: selectFilter({
        options:
          adminState.productsPage?.productTypes?.map((m) => {
            return {
              value: m.id ?? 0,
              label: m.description ?? '',
            }
          }) ?? [],
      }),
      formatter: (cell: any, m: AdminProductDTO, rowIndex: number, colIndex: number) => (
        <>
          <div className='text-dark fw-bold d-block fs-6'>{m.productTypeName}</div>
        </>
      ),
    },
    {
      dataField: 'categoryId',
      text: 'Kategori',
      sort: true,
      headerStyle: {width: '15%'},
      filter: selectFilter({
        options:
          adminState.productsPage?.productCategories?.map((m) => {
            return {
              value: m.id ?? 0,
              label: m.description ?? '',
            }
          }) ?? [],
      }),
      formatter: (cell: any, m: AdminProductDTO, rowIndex: number, colIndex: number) => (
        <>
          <div className='text-dark fw-bold d-block fs-6'>{m.category}</div>
        </>
      ),
    },
    // {
    //   dataField: 'description',
    //   text: 'Açıklama',
    //   sort: true,
    //   headerClasses: 'mw-500px',
    //   classes: 'mw-500px',
    //   width: 500,
    //   headerStyle: {width: '15%'},
    //   filter: textFilter(),
    //   formatter: (cell: any, m: AdminProductDTO, rowIndex: number, colIndex: number) => (
    //     <>
    //       <div className='text-dark fw-bold d-block fs-6'>{m.description}</div>
    //     </>
    //   ),
    // },
    {
      dataField: 'defaultPrice',
      text: "Varsayılan Fiyat (KDV''siz)",
      sort: true,
      headerStyle: {width: '10%'},
      formatter: (cell: any, m: AdminProductDTO, rowIndex: number, colIndex: number) => (
        <>
          <div className='text-dark fw-bold d-block fs-6 text-end'>
            {m.prices?.at(0)?.totalPriceWithoutTax ?? 0} {getCurrencySymbol(m.currencyId ?? 0)}
          </div>
        </>
      ),
    },
    {
      dataField: 'defaultPriceWithoutTax',
      text: "Varsayılan Fiyat (KDV'li)",
      sort: true,
      headerStyle: {width: '10%'},
      formatter: (cell: any, m: AdminProductDTO, rowIndex: number, colIndex: number) => (
        <>
          <div className='text-dark fw-bold d-block fs-6 text-end'>
            {m.prices?.at(0)?.totalPrice ?? 0} {getCurrencySymbol(m.currencyId ?? 0)}
          </div>
        </>
      ),
    },
    {
      dataField: '',
      text: 'Detay',
      sort: true,
      headerStyle: {width: '5%'},
      formatter: (cell: any, m: AdminProductDTO, rowIndex: number, colIndex: number) => (
        <>
          <div className='d-flex justify-content-center flex-shrink-0'>
            <div
              onClick={() => {
                setEditingProduct(m)
                setIsNewProduct(false)
              }}
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            >
              <KTSVG path='/media/icons/duotune/general/gen019.svg' className='svg-icon-3' />
            </div>
          </div>
        </>
      ),
    },
  ]

  const rowClasses = (row: AdminProductDTO, rowIndex: number): string => {
    return clsx({
      'bg-light-danger': !row.isActive,
    })
  }

  const newProduct: AdminProductDTO = {
    currencyId: 1,
    isActive: true,
    serviceLength: 1,
    serviceType: 6,
  }

  if (editingProduct) {
    return (
      <AdminProductEditPage
        product={editingProduct}
        isNew={isNewProduct}
        onBack={() => {
          setEditingProduct(null)
          setIsNewProduct(false)
        }}
      />
    )
  }

  return (
    <>
      <div className={`card card-stretch`}>
        <div className='card-body py-3'>
          {CanIDoThat(UserTypeAuthorizationsEnum.Admin_Panel_Product_Page_Edit) && (
            <div
              className='btn btn-primary btn-sm mb-5'
              onClick={() => {
                setEditingProduct(newProduct)
                setIsNewProduct(true)
              }}
            >
              Ürün Ekle +
            </div>
          )}

          <div className='table-responsive'>
            {(adminState.productsPage?.products?.length ?? 0) > 0 && (
              <BootstrapTable
                rowClasses={rowClasses}
                keyField='id'
                filter={filterFactory()}
                filterPosition='top'
                data={sortedProducts}
                columns={columns}
                classes='table table-hover table-row-dashed table-rounded mt-5'
              />
            )}
          </div>

          {/* begin::Table container */}

          {/* end::Table container */}
        </div>
        {/* begin::Body */}
      </div>
    </>
  )
}

export default AdminProductsPage
